
// => Cards
import cards from './cards.json';


export const boosterPacks = [
    {
        id: "booster_test",
        name: "Test Booster",
        pool: cards.test,
        cardsPerOpen: 3,
        showInCollection: false,
        unlockOverride: true,
    },
    {
        id: "booster_base-babes",
        name: "Starter Babes",
        pool: cards.baseBabes,
        cardsPerOpen: 0,
        showInCollection: true,
        unlockOverride: true,
    },
    {
        id: "booster_base-cocks",
        name: "Starter Cocks",
        pool: cards.baseCocks.concat(cards.baseShots),
        cardsPerOpen: 0,    // not used ATM? is defined in shop items!
        showInCollection: true,
        unlockOverride: true,
    },
    {
        id: "booster_xpac-bbc",
        name: "BBC Deluxe",
        pool: cards.xpacBbcDeluxe,
        cardsPerOpen: 0,    // not used ATM
        showInCollection: true,
        unlockOverride: false,   // TODO:
    },
    {
        id: "booster_xpac-girlcock",
        name: "Girl Cock",
        pool: cards.xpacGirlCock,
        cardsPerOpen: 0,    // not used ATM
        showInCollection: true,
        unlockOverride: false,   // TODO:
    }
]